export const detailsPointList = [
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section3_img1_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section3_img1_m.png',
    type: 'POINT 1',
    title: '멋쟁이사자처럼 단독 \n실무형 인턴십 기회 제공',
    descPc:
      '멋쟁이사자처럼에서 단독으로 준비한 인턴십 기회로 \n개발자로서의 실전 경험을 쌓을 수 있어요. 실제 서비스 \n개선 및 개발 업무를 행하며 나만의 커리어를 시작해 보세요!',
    descM:
      '멋쟁이사자처럼에서 단독으로 준비한 \n기회로 개발자로서의 실전 경험을 쌓을 \n수 있어요. 실제 서비스 개선 및 개발 \n업무를 수행하며 나만의 커리어를 \n시작해 보세요!',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section3_img2_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section3_img2_m.png',
    type: 'POINT 2',
    title: '기업이 요구하는 핵심 \n기술 스택 집중 학습',
    descPc:
      '프론트엔드 개발자에게 필수적인 기술 스택 HTML, CSS, \nJavaScript, React 등을 집중적으로 다뤄요. 실무에 바로 \n적용할 수 있도록 기본기부터 탄탄하게 배울 수 있어요.',
    descM:
      '프론트엔드 개발자에게 필수적인 \n기술 스택 HTML, CSS, JavaScript, \nReact 등을 집중적으로 다뤄요. \n실무에 바로 적용할 수 있도록 \n기본기부터 탄탄하게 배울 수 있어요.',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section3_img3_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section3_img3_m.png',
    type: 'POINT 3',
    title: '실무 중심 프로젝트로 \n취업 포트폴리오 완성',
    descPc:
      '취업 경쟁력을 갖추려면 이론보다 실제 개발 경험이 담긴 \n포트폴리오가 중요해요. 실무 프로젝트를 수행하며 \n협업 역량을 키우고, 기업이 원하는 수준의 결과물을 완성해 \n면접에서 강점을 어필하세요.',
    descM:
      '취업 경쟁력을 갖추려면 이론보다 \n실제 개발 경험이 담긴 포트폴리오가 \n중요해요. 실무 프로젝트를 수행하며 \n협업 역량을 키우고, 기업이 원하는 \n수준의 결과물을 완성해 면접에서 \n강점을 어필하세요.',
  },
]

export const curriculumDetailList = [
  {
    id: 0,
    step: 'STEP 1',
    title: 'HTML/CSS',
    iconUrl: [
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section7_step1_img1.png',
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section7_step1_img2.png',
    ],
    desc: '웹 페이지 구축의 기본! 깔끔한 레이아웃과 반응형 디자인을 익혀 실전에서도 통하는 UI를 구현할 수 있어요. CSS 애니메이션까지 배우면 사용자 경험까지 고려한 감각적인 웹을 만들 수 있어요.',
    descList: [
      'HTML 태그와 레이아웃 구성',
      'CSS flex, Grid를 이용한 레이아웃 구성',
      '반응형 웹 디자인 이해하기',
      'CSS Animation',
      'Magic Patterns, ChatGPT, Copilot 등 생성형 AI 활용법',
      'AI가 마크업에 미치는 영향 알아보기',
      'AI를 활용한 HTML/CSS 코드 생성 활용 및 허점 인식',
      'AI 플랫폼 별 코드 비교',
    ],
  },
  {
    id: 1,
    step: 'STEP 2',
    title: 'JavaScript & TypeScript',
    iconUrl: [
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section7_step2_img1.png',
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section7_step2_img2.png',
    ],
    desc: '정적인 웹사이트는 이제 그만! JavaScript로 동적인 기능을 추가해 더 생동감 있는 웹을 만들어요. ES6+ 문법과 TypeScript까지 익히면 더 안전하고 유지보수하기 쉬운 코드 작성도 문제없어요.',
    descList: [
      'JavaScript 기초 및 DOM 조작',
      'ES6+ 문법 소개',
      'TypeScript 프로그래밍',
      'AI가 프론트엔드 개발에 미치는 영향 알아보기',
    ],
  },
  {
    id: 2,
    step: 'STEP 3',
    title: 'Vanilla Project',
    iconUrl: [
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section7_step3_img1.png',
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section7_step3_img2.png',
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section7_step3_img3.png',
    ],
    desc: '라이브러리 없이 오직 HTML, CSS, JavaScript만으로 웹사이트를 직접 만들어보는 과정! 기초를 탄탄하게 다지면서, 프론트엔드의 핵심 개념을 몸으로 습득할 수 있어요.',
    descList: ['HTML/CSS, JavaScript를 사용, 웹 접근성을 고려한 프로젝트 진행'],
  },
  {
    id: 3,
    step: 'STEP 4',
    title: 'React',
    iconUrl: [
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section7_step4_img1.png',
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section7_step4_img2.png',
    ],
    desc: '프론트엔드의 가장 강력하고 유연한 기술, React로 컴포넌트 기반 개발을 익히고 CSR, 상태 관리까지 배우면 실무에서도 바로 적용 가능한 개발 역량을 갖출 수 있어요.',
    descList: [
      'CSR 개념 이해하기',
      '리액트 컴포넌트, JSX, Props, State',
      'Redux, Context API를 이용한 상태관리',
      '리액트 최적화 기법 이해하기',
      '리액트 훅(hooks) 사용하기',
      'SSR, CSR 비교',
      'AI 활용 개발 실습 (Chat-GPT, Cursor, Coedium 등)',
      '테스트 코드 자동 생성',
      '디버깅과 코드 리뷰',
      'AI 활용 리팩토링',
    ],
  },
  {
    id: 4,
    step: 'STEP 5',
    title: 'Final Project',
    iconUrl: [
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section7_step5_img1.png',
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section7_step5_img2.png',
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section7_step5_img3.png',
    ],
    desc: '이제 진짜 실전! React, TypeScript, Next.js 등 여태까지 배웠던 모든 기술 스택을 활용해 자율 프로젝트를 기획하고 배포까지 진행해요. 내 손으로 만든 프로젝트가 포트폴리오가 되고,기업이 원하는 실무 경험까지 쌓을 수 있어요.',
    descList: ['React, TypeScript, Next.js를 사용하여 자율 종합 프로젝트 기획·설계 및 배포'],
  },
]

export const projectOutputList = [
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section9_img1.mp4',
    thumbnail:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section9_img1_thumbnail.png',
    title: '해머거 (9기 수료생)',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section9_img2.mp4',
    thumbnail:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section9_img2_thumbnail.png',
    title: 'DIF (4기 수료생)',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section9_img3.mp4',
    thumbnail:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section9_img3_thumbnail.png',
    title: '럭킷 (3기 수료생)',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section9_img4.mp4',
    thumbnail:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section9_img4_thumbnail.png',
    title: '포레 (3기 수료생)',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section9_img5.mp4',
    thumbnail:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section9_img5_thumbnail.png',
    title: '쉼 (9기 수료생)',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section9_img6.mp4',
    thumbnail:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section9_img6_thumbnail.png',
    title: 'mofmof (4기 수료생)',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section9_img7.mp4',
    thumbnail:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section9_img7_thumbnail.png',
    title: '복근곰마켓 (3기 수료생)',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section9_img8.mp4',
    thumbnail:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section9_img8_thumbnail.png',
    title: '빵라다이스 (9기 수료생)',
  },
]

export const firstCompanyListPc = [
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img1.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img2.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img3.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img4.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img5.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img6.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img7.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img8.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img9.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img10.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img11.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img12.png',
]

export const firstCompanyListM = [
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img1.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img2.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img3.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img4.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img5.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img6.png',
]

export const secondCompanyList = [
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img7.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img8.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img9.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img10.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img11.png',
  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section10_img12.png',
]

export const reviewSlideFirstList = [
  {
    title: '프론트엔드, \n뚝딱 만들어낼 수 있게 됐어요',
    desc: '프론트엔드에 관해 아무것도 모르고 시작했지만 뚝딱 만들어내는 저를 보면서 신기하다는 생각을 하게 됐습니다 ㅎㅎ',
    who: '7기 수료생',
  },
  {
    title: '포기하지 않고 \n프로젝트를 완수했어요',
    desc: '프로젝트에 막연한 두려움이 있었던 저에게 포기하지 않고 프로젝트를 마칠 수 있던 곳이었습니다. 지인들한테도 추천할 의향이 있습니다.',
    who: '6기 수료생',
  },
  {
    title: '실전에서 쓰일 수 있는 \n기술을 배워요',
    desc: '많은 도움이 되었고 실전에서 쓰일 수 있는 기술만 알려주신다는 점에서 진짜 좋았습니다.',
    who: '7기 수료생',
  },
]

export const reviewSlideSecondList = [
  {
    title: '혼자서 공부할 때보다 \n더 많은 것들을 얻어요',
    desc: '처음엔 5개월이 엄청 길 줄 알았는데 너무 빠르게 지나가서 짧게 느껴지네요. 혼자서 공부할 때보다 더 많은 것들을 얻어 갈 수 있는 것 같아요.',
    who: '10기 수료생',
  },
  {
    title: '개발자로의 첫걸음, \n성장의 계기가 됐어요',
    desc: '개발자로 첫걸음을 떼기에 정말 적절했다고 생각하고, 많이 성장할 수 있었던 계기가 되었습니다. 앞으로 더 좋은 개발자가 될 수 있겠다는 자신감이 조금은 생긴 것 같습니다.',
    who: '10기 수료생',
  },
  {
    title: '전공자지만 몰랐던 \n많은 지식을 알려줘요',
    desc: '전공자이지만 몰랐던 부분이 되게 많았다. 대충 알려 주시는 게 아니라 많은 걸 알려주시려고 하는 게 느껴졌고 기술 지식도 최근 기술 지식에 대해서 항상 공부하고 계시다는 걸 느꼈다. 그게 정말 대단하신 거 같다.',
    who: '11기 수료생',
  },
]

export const reviewSlideThirdList = [
  {
    title: '열정적인 강사님, 매니저님, \n노력하는 동료와 함께해요',
    desc: '열정적인 강사님들과 친절한 매니저님들, 서로 배려하고 노력하는 학생들 덕분에 저도 끝까지 수료할 수 있었던 것 같습니다.',
    who: '11기 수료생',
  },
  {
    title: '강사님이 사소한 부분까지 \n케어해 주세요',
    desc: '선생님이 사소한 부분까지 케어해주시고 가르쳐 주셔서 비전공자임에도 불구하고 수업을 이해하는데 문제가 없었습니다. 정말 감사합니다.',
    who: '10기 수료생',
  },
  {
    title: '학습에 몰입할 수 있도록 \n세심하게 챙겨줘요',
    desc: '수강생을 세심하게 챙겨주는 과정은 처음이었고, 학습에 몰입할 수 있도록 환경도 잘 되어있어 좋았습니다. 짧은 시간에 폭발적으로 성장했다고 자부할 수 있습니다.',
    who: '8기 수료생',
  },
]

export const benefitDetailList = [
  {
    url: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section13_img1.png',
    step: '01',
    title: '데일리 회고 프로그램',
    desc: '진도에 잘 따라갈 수 있을까 걱정 이제 끝! 정규 수업 종료 후, 매일 2시간의 회고로 오늘 배운 내용을 복습할 수 있어요.',
  },
  {
    url: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section13_img2.png',
    step: '02',
    title: '프리러닝 VOD 혜택 제공',
    desc: '최종 합격자에게는 정규 과정이 시작되기 전까지 기초 학습 자료를 제공하니 빠르게 지원하고 기초 지식을 쌓아보세요.',
  },
  {
    url: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section13_img3.png',
    step: '03',
    title: 'AI를 활용한 프론트엔드 개발 최적화',
    desc: 'AI를 활용한 디버깅과 코드 리뷰로 개발 생산성을 극대화하세요. 클로드, GPT 등의 AI 도구를 통해 더 정교하고 스마트한 개발을 경험할 수 있어요!',
  },
  {
    url: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section13_img4.png',
    step: '04',
    title: '프론트엔드 서적 제공',
    desc: '더 나은 사용자 경험을 위한 ‘프론트엔드 성능 최적화 가이드’ 무료 제공! 실무에서 바로 적용할 수 있는 최적화 기술과 베스트 프랙티스를 확인하세요.',
  },
  {
    url: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section13_img5.png',
    step: '05',
    title: '1:1 코드 리뷰',
    desc: '직접 만든 과제와 프로젝트를 개발 지식이 풍부한 멘토에게 1:1 코드리뷰를 받으면서 더 나은 방향으로 개선해나갈 수 있어요.',
  },
]

export const benefitSlideList = [
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section16_benefit_img1_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section16_benefit_img1_m.png',
    title: '교육비 전액 무료',
    desc: '내일배움카드로 약 1,700만원 상당의 교육을 \n무료로 들을 수 있어요',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section16_benefit_img2_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section16_benefit_img2_m.png',
    title: '훈련장려금 신청',
    desc: '매월 최대 81만원까지 훈련장려금을 \n신청할 수 있어요',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section16_benefit_img3_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section16_benefit_img3_m.png',
    title: '교육 장비 지원',
    desc: '교육 시작 후, 교육 장비가 필요한 인원에 한하여 \n무료로 장비를 대여해 드려요',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section16_benefit_img4_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-14th/section16_benefit_img4_m.png',
    title: '오프라인 프로젝트 공간 지원',
    desc: '사전 신청자에 한하여 프로젝트를 진행할 수 있는 \n오프라인 공간을 지원해요',
  },
]

export const ApplyScheduleList1 = [
  {
    title: '서류 지원',
    content: '2025년 4월 16일 14:00까지',
  },
  {
    title: '결과 발표',
    content: '매주 금요일 오후 3시 \n(당일 낮 12시까지 제출자에 한함)',
    contentList: [
      '1차 : 3월 21일 금요일 오후 3시',
      '2차 : 3월 28일 금요일 오후 3시',
      '3차 : 4월 4일 금요일 오후 3시',
      '4차 : 4월 11일 금요일 오후 3시',
      '5차 : 4월 16일 수요일 오후 4시',
    ],
  },
  {
    title: '최종 합류\n(수강신청)',
    content: '고용24 수강신청',
  },
]

export const ApplyScheduleList2 = [
  {
    title: '서류 지원',
    content: '2025년 4월 20일 18:00까지',
  },
  {
    title: '결과 발표',
    content: '4/16 오후 2시 이후 제출 건은 3일 안에 발표 예정 \n(4월 20일 19:00 이전 최종 발표)',
    contentList: [
      '1차 : 3월 21일 금요일 오후 3시',
      '2차 : 3월 28일 금요일 오후 3시',
      '3차 : 4월 4일 금요일 오후 3시',
      '4차 : 4월 11일 금요일 오후 3시',
      '5차 : 4월 16일 수요일 오후 4시',
    ],
  },
  {
    title: '최종 합류\n(수강신청)',
    content: '고용24 수강신청',
  },
]

export const EduScheduleList = [
  {
    title: '교육 시작',
    content: '2025년 4월 21일(월)',
  },
  {
    title: '교육 종료',
    content: '10월 28일 (화)',
    caution: '*커리큘럼에 따라 변경될 수 있습니다.',
  },
  {
    title: '교육 시수',
    content: '115일 / 920H',
  },
  {
    title: '교육 시간',
    content: '평일 오전 9시 ~ 오후 6시 \n(일 8시간, 점심시간 제외)',
  },
  {
    title: '학습 형태',
    content: '100% 온라인 교육 \n(실시간 라이브)',
  },
]

export const bootCampFaqTabList = [
  { label: '전체', value: 'all' },
  {
    label: '지원',
    value: 'apply',
  },
  {
    label: '선발',
    value: 'nebeka',
  },
  {
    label: '취업',
    value: 'employment',
  },
  {
    label: '교육운영',
    value: 'edu',
  },
  {
    label: '특전혜택',
    value: 'benefit',
  },
  {
    label: '기타',
    value: 'etc',
  },
]

interface IBootCampFaqList {
  [key: string]: {
    question: string
    answer?: string
    secondAnswer?: string
    externalUrl1?: string
    urlName1?: string
    externalUrl2?: string
    urlName2?: string
    answerList?: string[]
  }[]
}

export const bootCampFaqList: IBootCampFaqList = {
  apply: [
    {
      question: '[지원] 지원 자격이 있나요?',
      answer:
        '국민내일배움카드를 보유하고 있거나 발급 가능하다면 누구든지 지원하실 수 있습니다. 발급 가능 여부는 고용노동부 1350 또는 거주지 관할 고용센터에서 직접 확인해주셔야 합니다. \n국민내일배움카드를 발급받고 교육 기간 동안 주 5일, 매일 약 8시간의 교육 과정에 온전히 참여하실 수 있다면 원칙상 수강할 수 있으나, 직장과 병행해야 해서 정해진 시간에 출석할 수 없고 하루 8시간의 학습 시간을 채울 수 없는 경우 선발에서 제외됨을 알려드립니다.',
    },
    {
      question: '[지원] 국민내일배움카드가 없어도 지원할 수 있나요?',
      answer:
        '지원은 가능합니다. 다만 최종 합격 발표 전까지는 모바일 앱 카드 혹은 실물 카드를 소지하고 있으셔야 합니다. \n모바일 앱 카드의 경우, 신청 당일에 즉시 발급이 가능하지만 오프라인 카드 발급은 최종 수령까지 일주일 이상 소요될 수 있기에 고용노동부 1350을 통해 카드 발급 자격 확인 및 발급 신청을 빠르게 하시는 것을 추천드립니다.',
    },
    {
      question: '[지원] 국민내일배움카드는 반드시 오프라인에서만 발급 받을 수 있나요?',
      answer:
        '국민내일배움카드는 고용24 홈페이지를 통해 신청 가능하며 오프라인과 온라인 모두 발급 받으실 수 있습니다. \n자세한 발급 과정은 아래 링크를 통해 확인 가능합니다.',
      externalUrl1: '/nebeca',
      urlName1: '국민내일배움카드 신청 방법 확인하기 (링크)',
      externalUrl2: '/nebeca/issued',
      urlName2: '국민내일배움카드 모바일 발급 방법 확인하기 (링크)',
    },
    {
      question: '[지원] 고용24 신청은 언제 할 수 있나요?',
      answer:
        '최종 합격자로 선발된 후, 합격하신 분들께 별도로 안내해 드릴 예정입니다. \n안내를 받으신 후 고용24에서 신청해주시면 됩니다.',
    },
    {
      question: '[지원] 비전공자도 지원 가능한가요?',
      answer:
        '네. 지원 가능합니다. 전공과 무관하게 프론트엔드 개발자가 되려는 강한 의지와 계획이 있으시면 됩니다. 다만, 합격 후 6개월 동안 정말 몰입해서 학습을 이어가셔야 합니다. 꾸준한 의지와 학습 습관으로 목표하시는 변화를 만들어내시기 바랍니다.',
    },
    {
      question: '[지원] 지원서 제출 후 수정 가능한가요?',
      answer: '지원서 수정은 불가능합니다. 항목을 미리 검토하신 후 제출하시기 바랍니다.',
    },
    {
      question: '[지원] 다른 부트캠프와 중복 지원 가능한가요?',
      answer:
        '멋쟁이사자처럼이 운영하는 다른 부트캠프와 중복 지원은 불가합니다. 다른 훈련기관이 운영하는 과정에 중복 지원하는 것은 가능합니다. 희망하는 부트캠프에 한해 하나만 지원 가능하므로 신중하게 고민하고 선택해주세요.',
    },
    {
      question: '[지원] 미성년자도 지원이 가능한가요?',
      answer:
        '아쉽지만 미성년자는 지원이 어렵습니다. \n해당 교육 과정은 성인을 대상으로 운영되고 있습니다.',
    },
  ],
  nebeka: [
    {
      question: '[선발] 선발 절차는 어떻게 되나요?',
      answer:
        '국민내일배움카드 신청 → 1차 지원서(서류) 제출 → 최종합격자 발표 → 고용24 수강신청 순으로 진행됩니다. \n국민내일배움카드 발급에 일주일 이상 소요되므로 발급 신청을 먼저 해주시기 바랍니다.',
    },
    {
      question: '[선발] 합격 확인은 어떻게 하나요?',
      answer:
        '각 단계별로 합격하신 분들께는 E-mail과 SMS로 안내드릴 예정입니다. 발표 일정은 상세페이지를 참고해주세요. \n*발표 일정은 상황에 따라 일부 변경될 수 있습니다.',
    },
  ],
  employment: [
    {
      question: '[취업] 취업 지원 프로그램이 제공되나요?',
      answer:
        '최신 채용 트렌드를 반영한 전문적인 이력서 및 포트폴리오 특강과 1:1 피드백을 통해 체계적인 취업 지원을 받으실 수 있습니다. 수료 후에도 지속적인 케어와 인턴십·채용 연계 기회를 제공합니다. \n*제공되는 프로그램 항목은 내부 사정에 의해 변경될 수 있으며 자세한 내용은 상세페이지를 참고해 주세요.',
    },
  ],
  edu: [
    {
      question: '[교육 운영] 교육은 어디서 진행되나요?',
      answer:
        '교육은 오프라인이 아닌, 온라인 라이브로 진행되며 국내에서, 거주 지역에 무관하게 학습할 수 있습니다.',
    },
    {
      question: '[교육 운영] 온라인 수업 출결은 어떻게 진행되나요?',
      answer:
        '두 가지 방법으로 출결이 진행됩니다. \n1. 고용24 앱 설치 후 QR코드 인증(개인 진행) \n2. 줌 모니터링을 통한 매시간 출결 체크(운영진 진행, 줌 화면에 얼굴이 정확히 확인되어야 출석 인정) \n추가로, 수업 참여 중 장소 이동은 불가합니다. 장소 이동 시 출결에 불이익이 발생하니 이점 유의 부탁드립니다.',
    },
    {
      question: '[교육 운영] 수업에 빠질 경우 강의를 다시 볼 수 있나요?',
      answer:
        '본 교육 과정은 학습을 포함한 모든 내용을 영상으로 추가 제공하지 않습니다. 따라서 다음 수업 내용을 잘 따라가기 위해서는 반드시 출석해주셔야 합니다.',
    },
    {
      question: '[교육 운영] 교육 기간 중 쉬는 날은 없나요?',
      answer:
        '교육 기간 내 주말, 공휴일에는 교육을 진행하지 않습니다. 수업 외 일정에 관해서는 오리엔테이션에서 자세하게 안내드릴 예정입니다. 교육기간 동안 온전하게 몰입하시는 것을 권유드립니다.',
    },
    {
      question: '[교육 운영] 해외에서도 참여할 수 있나요?',
      answer:
        'KDT 프로그램의 특성상, 해외에서 수강하는 것은 불가능합니다. 교육 참여 중에 해외로 이동하는 것 역시 불가능합니다.',
    },
  ],
  benefit: [
    {
      question: '[특전 혜택] 합격생에게 제공되는 혜택이 있나요?',
      answerList: [
        '· 멋쟁이사자처럼 수료생 커뮤니티 활동 기회를 제공합니다.',
        '· 수료 후 정기적으로 진행되는 행사참여 및 네트워킹 기회를 제공합니다. (KDT 수료생에 한함)',
        '· 이력서 특강 등 개인 맞춤 성장 프로그램을 제공합니다.',
      ],
    },
  ],
  etc: [
    {
      question: '[기타] 훈련장려금을 받을 수 있나요?',
      answer:
        '네. 훈련 장려금은 월 최대 316,000원까지 받으실 수 있으며, 매달 출석률에 따라 차등 지급됩니다. \n국민취업제도에 참여 중인 분들의 경우, 훈련 장려금 외에 추가 훈련 수당을 받으실 수 있으며 1유형에 해당하시는 분들은 500,000원의 훈련수당까지 더해 월 최대 816,000원을 지급받으실 수 있고 2유형에 해당하시는 분들은 284,000원의 훈련수당까지 더해 월 최대 600,000원을 지급받으실 수 있습니다. \n다만, 개인의 상황에 따라 참여 가능한 유형이 다르고 지급받을 수 있는 금액이 다를 수 있기에 반드시 고용24를 통해 확인 및 신청 바랍니다.',
    },
    {
      question: '[기타] 훈련 자비 부담액은 얼마인가요?',
      answer: '본 교육과정은 내일배움카드를 소지하신 분들을 대상으로 전액 무료로 진행됩니다.',
    },
  ],
}
